import React from 'react';
import Grid from '@material-ui/core/Grid';

const ListingSkeleton = () => {
    return (<Grid className='listing' container spacing={0}>
        <Grid item xs={12}>
            <div className='listing-skeleton'>
                <div className='alert success'/>
                <div className='draft-status-n-id'>
                    <div className='draft-id'/>
                    <div className='draft-status'/>
                </div>
                <div className='title hide-desktop'/>
                <div className='item-photo-n-properties'>
                    <div className='item-photo'/>
                    <div className='properties'>
                        <div className='title'/>
                        <div className='item-edit-button'/>
                        <div className='item-property hide-desktop one'/>
                        <div className='item-property hide-desktop two'/>
                        <div className='item-property three'/>
                        <div className='alert microscope'/>
                    </div>
                </div>
                <div className='title title-similar-items'/>
                <div className='similar-items'>
                    <div className='similar-item'/>
                    <div className='similar-item'/>
                    <div className='similar-item'/>
                    <div className='similar-item'/>
                </div>
                <div className='title'/>
            </div>
        </Grid>
    </Grid>);
};

export default ListingSkeleton;